export class Exception extends Error {
    constructor(message = 'Sorry, something went wrong.', status = 500, innerException, moreInfo) {
        super(message);
        this.status = status;
        this.innerException = innerException;
        this.moreInfo = moreInfo;
        this.isHTTPResponse = true;
        this.statusCode = status;
        Object.setPrototypeOf(this, Exception.prototype); // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    }
}
//# sourceMappingURL=Exception.js.map


// WEBPACK FOOTER //
// ../../src/models/Exception.ts